<template>
  <div class="tzflow">
    <el-form ref="formData" :rules="rules" :model="formData" label-position="left" size="small">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="标题" prop="title" label-width="80px">
            <el-input v-model.trim="formData.title" size="small" maxlength="30" show-word-limit :disabled="flowStatus">
            </el-input>
            <span slot="error" class="item-error">
              <span>请填写标题</span>
            </span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="flowStatus" :gutter="24">
        <el-col :span="12">
          <el-form-item label="项目名称" prop="prjName" label-width="80px">
            <el-input v-model="formData.prjName" size="small" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目编号" prop="prjCode" label-width="80px">
            <el-input v-model="formData.prjCode" size="small" disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="flowStatus" :gutter="24">
        <el-col :span="12">
          <el-form-item label="申请人" prop="operUserName" label-width="80px">
            <el-input v-model="formData.operUserName" size="small" disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提交时间" prop="operTime" label-width="80px">
            <el-input v-model="formData.operTime" size="small" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24" style="line-height: 20px">
        <el-col :span="24">
          <el-form-item label="提资文件" label-width="80px">
            <div style="display: flex;align-items: baseline;">
              <div style="float:left">
                <el-button :disabled="flowStatus" size="small" @click="uploadFolder('guanlianfile')"> <i class="el-icon-plus"></i>关联文档</el-button>
                <el-button :disabled="flowStatus" size="small" @click="uploadFolder('file')"> <i class="el-icon-plus"></i>本地上传</el-button>
              </div>
              <span style="margin-left:20px">
                <el-checkbox v-if="formData.isOverwriteSameNameFile === 1" v-model="formData.isOverwriteSameNameFile"
                  :disabled="flowStatus" :true-label="1" :false-label="0">同名文件覆盖
                </el-checkbox>
                <el-checkbox v-else v-model="formData.isOverwriteSameNameFile" :disabled="flowStatus" :true-label="1"
                  :false-label="0">同名文件重命名
                </el-checkbox>
              </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="提资专业" prop="carryInfoSpecialty" label-width="80px">
            <!-- rvt端和cad右键发起不可选择专业 -->
            <template v-if="!clientType||startFlowMode===0">
              <el-select v-if="!flowStatus" v-model="formData.carryInfoSpecialty" size="small" style="width: 100%"
                clearable filterable :disabled="flowStatus" @change="specialtyChange">
                <el-option v-for="item in specList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
              <el-input v-else v-model="formData.carryInfoSpecialtyName" disabled size="small"></el-input>
            </template>
            <template v-else>
              <el-select v-if="!flowStatus" v-model="formData.carryInfoSpecialty" size="small" style="width: 100%"
                clearable filterable disabled>
                <el-option v-for="item in specList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
              <el-input v-else v-model="formData.carryInfoSpecialtyName" disabled size="small"></el-input>
            </template>
            <span slot="error" class="item-error">
              <span>请选择提资专业</span>
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="存放目录" prop="fileLocationName" label-width="80px">
            <el-input v-model="formData.fileLocationName" style="width: 100%" size="small" readonly :disabled="flowStatus" @focus="recelocation">
            </el-input>
            <span slot="error" class="item-error">
              <span>请选择存放目录</span>
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="接收专业" prop="acceptSpecialty" label-width="80px">
            <el-select v-if="!flowStatus" v-model="formData.acceptSpecialty" size="small" style="width: 100%" multiple
              clearable filterable :disabled="flowStatus" @change="change_showStartButtons">
              <el-option v-for="item in specAcceptList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <el-input v-else v-model="formData.acceptSpecialtyName" disabled size="small"></el-input>
            <span slot="error" class="item-error">
              <span>请选择接收专业</span>
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联计划" prop="prjPlanId" label-width="80px">
            <el-select v-if="!flowStatus" v-model="formData.prjPlanId" size="small" style="width: 100%" clearable filterable :disabled="flowStatus" @change="changePrjPlan" @focus="focusPrjPlan">
              <el-option v-for="item in prjPlanData" :key="item.taskId" :label="item.taskName" :value="item.taskId" />
            </el-select>
            <el-input v-else v-model="formData.prjPlanName" disabled size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="内容" prop="content" label-width="80px" style="margin-bottom:8px">
            <el-input v-model.trim="formData.content" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
              style="width: 100%" maxlength="200" show-word-limit :disabled="flowStatus"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <template v-if="clientType===2&&startFlowMode===1">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="提资模型" label-width="80px">
              <div class="fileList">
                <div v-for="file in formData.modelList" :key="file.fileId" class="file">
                  <div class="fileText">
                    <!-- 轻量化图标 -->
                    <fileLightFlag v-if="routerParams.flowStatus&&routerParams.status" :row="file" :form-flow="true"
                      @updateLight="updateLight" />
                    <img :src="className(file)" alt="" />
                    <el-link class="fileNameStyle" type="primary" @click="preview(file)">{{ file.fileName }}</el-link>
                  </div>
                  <div v-if="flowStatus" class="options">
                    <i class="el-icon-download" title="下载" style="margin-right: 15px; color: var(--theme-color)"
                      @click="downLoadFile(file)" />
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="提资视图" label-width="80px">
              <el-table :data="formData.submitDataViewList" border style="margin:5px 0px">
                <el-table-column label="视图名称" prop="viewName" align="center" show-overflow-tooltip />
                <el-table-column label="类型" prop="type" align="center" show-overflow-tooltip />
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>
    <!-- 存放目录 -->
    <el-dialog v-dialogDrag append-to-body :visible.sync="historyRecordDialog" :close-on-click-modal="false"
      :close-on-press-escape="false" title="存放目录" width="600px">
      <el-tree ref="frameTree" :data="frameTree" :class="[{ activeShowBar: !showBar }]" :props="defaultProps"
        :expand-on-click-node="false" class="tree" accordion highlight-current node-key="folderId"
        :default-expanded-keys="frameTreeDefaultExpandedKeys" @node-click="ChangeHandler" @node-expand="treeExpand"
        @node-collapse="treeCollapse">
        <template #default="{ data }">
          <span class="treeitem">
            <img :src="icon" style="margin-right: 6px" alt="文件" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <div style="display: flex;justify-content: space-between;">
          <div>
            <el-button v-if="isShowAddFolder&&addXtDesign" plain type="primary" size="small" @click="addFolder">新建文件夹</el-button>
          </div>
          <div>
            <el-button size="small" @click="historyRecordDialog=false">取 消</el-button>
            <el-button type="primary" size="small" @click="recelocationBtn">确 定</el-button>
          </div>
        </div>

      </span>
    </el-dialog>
    <!-- 关联文件 -->
    <!-- 提资关联文件 -->
    <el-dialog v-dialogDrag append-to-body :visible.sync="fileDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :close="cancel" title="关联文件" width="600px">
      <el-tree v-if="showBar" ref="typeTree" v-loading="loading" :data="fileTree" :props="defaultFileProps"
        :check-on-click-node="true" element-loading-text="拼命加载中" default-expand-all class="tree" node-key="folderId"
        accordion highlight-current show-checkbox @check="currentOrgChangeHandler">
        <template #default="{ data }">
          <span class="treeitem">
            <img v-if="data.isFolder == 0" :src="className(data)" class="img" alt="" />
            <img v-else :src="icon" class="img" alt="" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <el-tree v-else ref="bimexTree" :load="getBimexTree" :props="defaultFileProps" :check-on-click-node="true"
        element-loading-text="拼命加载中" :default-expanded-keys="defaultExpandedKeys" class="tree activeShowBar" lazy
        accordion highlight-current show-checkbox node-key="folderId" @check="currentOrgChangeHandler">
        <template #default="{ data }">
          <span class="treeitem">
            <img v-if="data.isFolder == 0" :src="className(data)" class="img" alt="" />
            <img v-else :src="icon" class="img" alt="" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fileDialog = false">取消</el-button>
        <el-button type="primary" size="small" @click="filerecelocationBtn">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 视图框 -->
    <el-dialog v-dialogDrag append-to-body :visible.sync="viewsDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      title="选择视图" width="400px" :close="closeViewsDialog">
      <!-- <el-row :span="24">
        <el-col :span="24">
          <div style="display: flex;align-items: center;">
            <span>图纸集：</span>
            <el-select v-model="" placeholder="">
              <el-option :label="" :value=""></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row> -->
      <el-tree ref="checkViewTree" v-loading="exportViewsListLoading" :data="viewsTreeData" :props="viewsTreeProps"
        node-key="id" highlight-current show-checkbox element-loading-text="视图导出中..." @check="checkViews">
        <template #default="{ data }">
          <span class="treeItem">
            <img v-if="data.viewType == '视图' && data.isLeaf" :src="viewIcon" style="margin-right: 6px" alt="视图" />
            <img v-if="data.viewType == '图纸' && data.isLeaf" :src="viewIcon" style="margin-right: 6px" alt="图纸" />
            <span>{{ data.name }}</span>
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeViewsDialog">取 消</el-button>
        <el-button type="primary" size="small" :loading="exportViewsListLoading" @click="submitViewsList">确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import docService from "@/CommonDP/service/doc-service";
import approval from "@/CommonDP/service/approve-service";
import flowService from "@/CommonDP/service/flow-service";
import { tableRowIcon, noLabelFilePreview, is3DModel, is2DModel } from "@/CommonDP/utils/docPublic";
import xtDesign from "@/CommonDP/service/integratedModel-service";
import { mapState } from "vuex";
import { downloadFile, flowFileDownLoad } from "@/CommonDP/utils";
import workProjectBoardService from "@/CommonDP/service/workProjectBoard-service";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";
import fileIcon from "@/CommonDP/components/FileList/FileIcon.vue";
import { uploader } from "@/CommonDP/utils/IUploader/dp.js";
export default {
  components: { fileLightFlag, fileIcon },
  props: {
    // 流程版本号。与 flowKey 两者不可同时为空
    flowDefinitionId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      viewIcon: require("@/CommonDP/assets/flowIcon/viewIcon.png"),
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      specList: [],
      specAcceptList: [],
      specChildrenList: [],
      rules: {
        title: [{ required: true, message: "请填写标题", trigger: "blur" }],
        // content: [{ required: true, message: "请填写内容", trigger: "blur" }],
        carryInfoSpecialty: [{ required: true, message: "请选择提资专业", trigger: "change" }],
        fileLocationName: [{ required: true, message: "请选择存放目录", trigger: "change" }],
        acceptSpecialty: [{ required: true, message: "请选择接收专业", trigger: "change" }]
      },
      historyRecordDialog: false,
      frameTree: [],
      defaultProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf"
      },
      defaultExpandedKeys: [],
      currentDepartment: {}, // 存放选中
      RootNode: [
        {
          folderName: "提资区",
          folderId: "1630981803194",
          childList: []
        }
      ],
      fileDialog: false,
      fileTree: [],
      defaultFileProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf"
      },
      currentFile: {}, // 提资关联文档
      loading: false,
      node_had: {},
      resolve_had: {},
      readonly: false, // 用以替换 flowStatus
      flowStatus: false,
      formData: {
        title: "",
        isOverwriteSameNameFile: 1,
        modelList: [],
        submitDataViewList: [],
        carryInfoSpecialty: "",
        carryInfoSpecialtyName: "",
        acceptSpecialty: [],
        acceptSpecialtyName: "",
        prjPlanId: '',
        prjPlanName: ''
      },
      viewsDialog: false,
      viewsTreeData: [],
      viewsTreeProps: {
        label: "name"
      },
      viewsList: [],
      exportViewsListLoading: false,
      prjPlanData: [],
      frameTreeDefaultExpandedKeys: [],
      list: [],
      addXtDesign: checkPermission(this.$allPerms.XTDESIGN_ADD),
      val: '',
      specId: ''
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo,
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    // cad跳转样式 rvt跳转样式
    showBar() {
      if (window.location.href.indexOf("jsName=BimEx") !== -1) {
        return false;
      } else {
        return true;
      }
    },
    isShowAddFolder() {
      const data = this.currentDepartment || {};
      const isShow = data.folderType ? data.folderType !== 13 && data.folderType !== 16 && data.folderType !== 14 && data.folderType !== 18 : false;
      return data.folderNew === 1 && isShow;
    },
    clientType() {
      return Number(this.routerParams.clientType);
    },
    startFlowMode() {
      return Number(this.routerParams.startFlowMode);
    },
    fileInfoList() {
      return this.routerParams.fileInfoList;
    },
    lastfolderId() {
      return this.routerParams.lastfolderId;
    }
  },
  watch: {
    "formData.carryInfoSpecialty"(newValue, oldValue) {
      if (newValue) {
        this.getPlanTaskList();
      } else {
        this.formData.prjPlanId = '';
        this.formData.prjPlanName = '';
        this.prjPlanData = [];
      }
    }
  },
  async created() {
    this.formData.approveUserName = this.userInfo.name;
    this.formData.title = this.userInfo.name + "发起" + this.routerParams.name;
    await this.getSpecList();
    await this.getAcceptSpecList();
    this.$nextTick(() => {
      this.$refs.formData.clearValidate();
    });
    if (this.clientType === 2 && this.startFlowMode === 1 && !this.showBar) {
      this.viewsAndFile();
      this.setModelList([this.fileInfoList[0]]);
    }
    if (!this.flowStatus && this.startFlowMode === 1 && !this.showBar) {
      this.setFileLocation(this.lastfolderId || "");
    }
  },
  methods: {
    updateLight(row, type) {
      const prjId = this.routerParams.enterpriseId || this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.fileId, row.fileVersion)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },
    treeExpand(data, node) {
      node.isExpand = true;
      this.currentDepartment = data;
    },
    treeCollapse(data, node) {
      node.isExpand = false;
      this.currentDepartment = data;
    },
    addFolder() {
      const { folderId } = this.currentDepartment;
      this.$prompt("", "新建文件夹", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入文件夹名称",
        inputPattern: /^\S*$/,
        inputErrorMessage: "文件夹名称不能包含空格",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        inputValidator: value => {
          if (!value) {
            return "文件夹名称不能为空";
          }
          if (value.length > 80) {
            return "文件夹名称不能大于80个字符";
          }
          var regExp = new RegExp('[\\\\|/:*<>?"]');
          if (regExp.test(value)) {
            return '文件夹名称不能包含以下字符:\\ / : * " ? < > |';
          }
          this.val = value;
        },
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            const prjId = this.routerParams.prjId ? this.routerParams.prjId : this.prjInfo.prjId;
            const parentId = folderId;
            const folderName = this.val.replace(/\s*/g, "");
            const data = { parentId, folderName, prjId };
            try {
              const result = await docService.queryAddFolder(data);
              if (result.result === "0") {
                this.currentDepartment = result.data;
                this.$message.success("新建成功");
                this.getFrameTree();
                done();
              }
            } catch (e) {
              console.log(e);
            }
          } else {
            done();
          }
        }
      }).catch(() => {});
    },
    setAcceptSpecialty(formData) {
      this.formData.acceptSpecialty = formData.json.acceptSpecialty.split(",");
    },
    setSpecId(specId) {
      this.$set(this.formData, "carryInfoSpecialty", specId);
    },
    async setFileLocation(lastfolderId, type) {
      this.$set(this.formData, "fileLocationName", "");
      if (type === 'file') {
        const { data } = await flowService.queryTzDepositFolderByDesignFile(lastfolderId);
        this.formData.fileLocation = data[data.length - 1].folderId;
        this.formData.fileLocationName = data.map(({ folderName }) => folderName).join("\\");
        this.currentDepartment.folderId = this.formData.fileLocation;
      } else {
        const { data } = await workProjectBoardService.getAssociatedFolderLocation(lastfolderId);
        this.formData.fileLocationName = data.map(({ folderName }) => folderName).join("\\");
        this.formData.fileLocation = lastfolderId;
        this.currentDepartment.folderId = lastfolderId;
      }
      this.historyRecordDialog = false;
      this.frameTree = [];
    },
    // 接口：用于获取表单数据
    getFormData() {
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      const acceptSpecialty = typeof this.formData.acceptSpecialty === "string" ? this.formData.acceptSpecialty : this.formData.acceptSpecialty.join();
      return {
        ...this.formData,
        acceptSpecialty,
        prjId: prjID
      };
    },

    // 接口：设置表单数据
    async setFormData(formData) {
      const acceptSpecialty = typeof formData.acceptSpecialty === "string" ? formData.acceptSpecialty.split(',') : formData.acceptSpecialty;
      const data = {
        ...formData,
        acceptSpecialty
      };
      this.formData = data;
    },
    // 重置表单数据
    resetForm() {
      this.formData.title = this.userInfo.name + "发起" + this.routerParams.name;
      this.formData.isOverwriteSameNameFile = 1;
      this.formData.modelList = [];
      this.formData.submitDataViewList = [];
      this.formData.prjPlanId = "";
      this.formData.prjPlanName = "";
    },
    // 接口：校验表单数据
    validateFormData() {
      let flag = null;
      this.$refs.formData.validate(valid => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },

    // 接口：校验表单数据
    validate() {
      let flag = null;
      this.$refs.formData.validate(valid => {
        if (valid) flag = true;
        else flag = false;
      });
      return flag;
    },

    // 接口：用于获取校审模型
    getModelList() {
      if (this.formData.modelList) {
        this.formData.modelList.forEach(ele => {
          ele.uploadType = 0;
        });
        return this.formData.modelList;
      } else {
        return [];
      }
    },

    // 接口：用于赋值模型
    setModelList(modelList) {
      if (!modelList.length) return;
      modelList[0].fileType = Number(modelList[0].fileType);
      this.formData.modelList = modelList;
    },

    // 如果是revit端的话还得删除表单里的对应的视图
    deleViewObj(obj) {
      this.formData.submitDataViewList = this.formData.submitDataViewList.filter(ele => ele.id !== obj.viewId);
      this.viewsList = this.viewsList.filter(ele => ele.id !== obj.viewId);
    },

    // 初始化视图数据
    async viewsTreeData_init() {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      const data = await cefSharpBrower.revitViewDatas("abc");
      const { viewDatas, viewSheetDatas } = JSON.parse(data) || {};
      this.viewsTreeData = [viewDatas, viewSheetDatas];
    },
    closeViewsDialog() {
      this.viewsDialog = false;
    },
    async checkViews(val, currentChecked) {
      this.viewsList = currentChecked.checkedNodes;
    },
    submitViewsList() {
      this.formData.submitDataViewList = this.viewsList.filter(({ isLeaf }) => isLeaf);
      this.formData.submitDataViewList.forEach(ele => {
        ele.viewId = ele.id;
        ele.viewName = ele.name;
        ele.type = ele.viewType;
      });
      this.exportViewsListLoading = true;
      this.exportView();
      this.exportViewsListLoading = false;
      this.closeViewsDialog();
    },

    // 导出视图
    async exportView() {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      const param = this.viewsList.filter(({ isLeaf }) => isLeaf);
      const list = [];
      await this.queryRevitApproval(param, 0, list);
    },
    async queryRevitApproval(param, index, list) {
      const str = JSON.stringify([param[index]]);
      const data = await cefSharpBrower.revitApproval(str); // revitApproval提资 跟校审有差别
      const arr = JSON.parse(data) || [];
      if (arr.length > 0) {
        arr.forEach(ele => {
          list.push(ele);
        });
        const i = index + 1;
        const l = param.length - 1;
        if (i <= l) {
          this.queryRevitApproval(param, i, list);
        } else {
          this.handleView(list, param);
        }
      }
    },
    // 处理返回的视图文件
    async handleView(data, param) {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      const str = JSON.stringify(param);
      cefSharpBrower.lightweightRvtFile(str);
      const fileList = data || [];
      fileList.forEach(ele => {
        ele.uploadType = 3;
        ele.fileType = Number(ele.fileType);
        // 将文件id给到表格里的fileId
        this.formData.submitDataViewList.forEach(res => {
          if (res.id === ele.viewId) {
            res.fileId = ele.fileId;
          }
        });
      });
      this.$emit("setRvtFileList", fileList || [], this.formData.submitDataViewList);
    },

    async getSpecList() {
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      const res = await flowService.querySpecList(prjID);
      if (res.data) this.specList = res.data.flowSpecPoList || [];
      if (this.$route.query.major) {
        this.formData.carryInfoSpecialty = this.$route.query.major || "";
        this.formData.carryInfoSpecialtyName = this.specList.find(e => e.id === this.$route.query.major)?.name;
      }
    },
    async getAcceptSpecList() {
      const prjId = this.routerParams.prjId ? this.routerParams.prjId : this.prjInfo.prjId;
      const res = await flowService.queryPrjAcceptSpecialtyList(prjId);
      this.specAcceptList = res.data || [];
    },
    async getPlanTaskList() {
      const specId = this.formData.carryInfoSpecialty || '';
      const { prjId } = this.routerParams;
      const prjID = prjId || this.prjInfo.prjId;
      const res = await flowService.prjPlanTaskFlowList(this.flowDefinitionId, specId, prjID);
      if (res.data) this.prjPlanData = res.data || [];
    },
    specialtyChange() {
      this.formData.prjPlanId = '';
      this.formData.prjPlanName = '';
      this.$set(this.formData, "fileLocationName", "");
      // 切换专业 隐藏发起按钮
      this.change_showStartButtons();
    },
    // 切换专业 隐藏发起按钮
    change_showStartButtons() {
      this.$emit("change_showStartButtons");
    },
    recelocation() {
      if (this.formData.carryInfoSpecialty) {
        this.historyRecordDialog = true;
        this.currentDepartment.folderId = this.formData.fileLocation;
        this.getFrameTree();
      } else {
        this.$message({
          message: "请先选择提资专业",
          type: "warning"
        });
      }
    },
    ChangeHandler(val) {
      this.currentDepartment = val;
    },
    recelocationBtn() {
      const obj = this.currentDepartment;
      if (obj.folderId) {
        if (obj.folderId !== "1630981803194") {
          if (obj.isReadOnly === 0) {
            this.setFileLocation(obj.folderId);
          } else {
            this.$message.warning("系统文件夹非最底级不可存放文件，请重新选择");
          }
        } else {
          this.$message.warning("请选择提资区下面的文件作为存放目录");
        }
      }
      this.currentDepartment = {};
    },
    // 获取存放目录
    async getFrameTree() {
      this.frameTree = [];
      const params = {
        prjId: this.prjInfo.prjId || this.routerParams.prjId,
        isRead: 1,
        priviAll: 0,
        folderId: "1630981803194",
        noRightClickMenu: true,
        level: 99
      };
      await approval.docList(params).then(async ({ data }) => {
        this.list = data;
        this.RootNode[0].childList = this.frameTreeFilter(this.list);
        this.frameTree = this.RootNode;
        this.$nextTick(() => {
          this.frameTreeDefaultExpandedKeys = [this.currentDepartment.folderId];
          this.$refs.frameTree.setCurrentKey(this.currentDepartment.folderId);
          this.currentDepartment = this.$refs.frameTree.getCurrentNode();
        });
      });
    },
    frameTreeFilter (list) {
      return list.filter(item => {
        if (item.childList !== null) {
          item.childList = this.frameTreeFilter(item.childList);
        }
        return item.isFolder === 1 && (item.specId === "0" || this.formData.carryInfoSpecialty === item.specId);
      });
    },
    async uploadFolder(type) {
      const {
        showBar,
        specList,
        formData: { carryInfoSpecialty }
      } = this;
      console.log(showBar);
      if (type === "guanlianfile" && showBar) {
        this.specId = '';
        this.loading = true;
        this.fileDialog = true;
        const id = specList.map((item) => item.id);
        const params = {
          prjId: this.routerParams.prjId ? this.routerParams.prjId : this.prjInfo.prjId,
          noFilterSpecIdList: id,
          isRead: 1,
          priviAll: 1,
          folderId: "1630981681702"
        };
        const res = await approval.queryTzDocTree(params);
        // rvt端  右键发起  过滤掉rvt文件
        if (this.clientType === 2 && this.startFlowMode === 1) {
          this.fileTree = this.filterTree(res.data); // 过滤rvt文件
        } else {
          this.fileTree = res.data;
        }
        this.loading = false;
      } else if (type === "guanlianfile" && !showBar) {
        this.node_had.childNodes = []; // 把存起来的node的子节点清空，不然会界面会出现重复树！
        this.getBimexTree(this.node_had, this.resolve_had); // 再次执行懒加载的方法
        this.fileDialog = true;
      } else {
        const params = {
          prjId: this.routerParams.prjId ? this.routerParams.prjId : this.prjInfo.prjId,
          folderId: "",
          versionId: ""
        };
        await uploader.getHiddenParams(params);
        const array = await uploader.open({ params, once: false, multiple: true, showPanel: false });
        const list = array.map((item) => {
          return {
            checkInDate: item.checkInDate,
            checkInUser: item.checkInUser,
            fileId: item.fileId,
            fileName: item.fileName,
            fileSize: item.fileSize,
            fileType: item.fileType,
            status: item.status,
            uploadType: 1,
            versionIds: item.versionIds
          };
        });
        this.$emit("tableshow", list || [], "upload");
      }
    },
    filterTree(tree, arr = []) {
      if (!tree.length) return [];
      for (const item of tree) {
        // 循环数组，然后过滤数据
        // 如果该条数据type不为0时，跳出本次循环
        if (item.fileType === 7 || item.fileType === 21) continue;
        // 如果满足条件时，用新node代替，然后把chilren清空
        const node = { ...item, childList: [] };
        // 然后添加到新数组中
        arr.push(node);
        // 如果有子节点，调用递归函数，并把空数组传给下一个函数
        // 利用引用数据类型的特性，实现浅拷贝
        // 递归函数过滤时会改变这个空数组数据，从而实现层级结构过滤
        if (item.childList && item.childList.length) {
          this.filterTree(item.childList, node.childList);
        }
      }
      return arr;
    },
    async getBimexTree(node, resolve) {
      const { carryInfoSpecialty } = this.formData;
      const prjId = this.routerParams.prjId ? this.routerParams.prjId : this.prjInfo.prjId;
      if (node.level === 0) {
        this.node_had = node; // 这里是关键！在data里面定义一个变量，将node.level == 0的node存起来
        this.resolve_had = resolve; // 同上，把node.level == 0的resolve也存起来
        const params = {
          folderId: 0,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId
        };
        const result = await docService.queryTree(params);
        const list = result.data.filter(({ folderType }) => folderType === 101); // 设计区
        const array = list.map(item => {
          const { childFlag = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            fileVersion: item.fileVersion,
            status: item.status,
            uploadType: 2,
            leaf: childFlag === 0,
            specId: item.specId
          };
        });
        this.$nextTick(() => {
          node.childNodes[0].expanded = true;
          node.childNodes[0].loadData();
        });
        return resolve(array);
      } else if (node.level !== undefined) {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          noRightClickMenu: true,
          prjId: this.prjInfo.prjId || this.routerParams.prjId
        };
        const res = await docService.queryTree(params);
        const speceList = [];
        const arr = this.specList.map(i => i.id);
        res.data.forEach(item => {
          if (item.specId === '0' || arr.includes(item.specId)) {
            speceList.push(item);
          }
        });
        const listArray = speceList.map(item => {
          const { childFlag = 0 } = item;
          return {
            isRead: item.isRead,
            priviAll: item.priviAll,
            folderName: item.folderName,
            folderId: item.folderId,
            isFolder: item.isFolder,
            fileType: item.fileType,
            fileVersion: item.fileVersion,
            status: item.status,
            leaf: childFlag === 0,
            uploadType: 2,
            specId: item.specId
          };
        });
        return resolve(listArray);
      }
    },
    currentOrgChangeHandler(val, currentChecked) {
      if (this.currentFile.length === 0) {
        this.specId = '';
      }
      if (!this.specId) {
        this.specId = val.specId;
      }
      if (val.specId !== this.specId) {
        if (this.showBar) {
          this.$refs.typeTree.setChecked(val.folderId, false, true);
        } else {
          this.$refs.bimexTree.setChecked(val.folderId, false, true);
        }
        this.$message.warning("不能跨专业选文件");
        return;
      }
      this.currentFile = currentChecked.checkedNodes;
    },
    className(row) {
      return tableRowIcon(row);
    },
    async filerecelocationBtn() {
      const list = this.currentFile.filter(({ isFolder }) => isFolder === 0);
      const listMap = list.map(item => {
        return {
          fileName: item.folderName,
          fileId: item.folderId,
          fileType: item.fileType,
          status: item.status,
          versionIds: item.fileVersion,
          uploadType: 2
        };
      });
      const res = new Map();
      const floderData = listMap.filter(a => !res.has(a.fileName) && res.set(a.fileName, 1));
      console.log(floderData, "floderData");
      if (floderData.length > 0) {
        this.$emit("tableshow", floderData || []);
        this.fileTree = [];
        this.fileDialog = false;
        if (this.startFlowMode !== 1) {
          this.formData.carryInfoSpecialty = this.specId;
        }
        if (!this.formData.fileLocationName) {
          const fileId = floderData[floderData.length - 1].fileId;
          this.setFileLocation(fileId, 'file');
        }
      } else {
        this.$message.warning("请选择文件");
      }
    },
    cancel() {
      this.fileTree = [];
    },
    async preview(row) {
      const value = {
        folderId: row.fileId,
        folderName: row.fileName,
        parentId: row.parentId,
        fileVersion: row.versionIds || 1,
        fileType: Number(row.fileType),
        status: row.status
      };
      if (value.status === 2) {
        value.status = value.status.toString();
      }
      const prjId = this.routerParams.prjId || this.prjInfo.prjId;
      // 获取当前项目的名称
      const prjList = await this.getprjList();
      const prj = prjList.find(item => item.prjId === prjId);
      const prjName = prj?.prjName || "";
      const flowInstanceId = this.routerParams.flowInstanceId || '';
      const obj = {
        fileId: row.fileId,
        // fileNames: row.fileName,
        prjId,
        // prjName,
        status: row.status,
        versionIds: row.fileVersion || 1,
        fileType: Number(row.fileType),
        source: "ct",
        flowInstanceId
      };
      // web端用value CAD端用obj
      // 判断是否为cad、revit打开的
      if (!this.showBar) {
        obj.noNeedIssue = true;
        await this.isSuccess(obj);
      } else {
        noLabelFilePreview(value, prjId, prjName, "ct", true, "", flowInstanceId);
      }
    },
    async isSuccess(obj) {
      const { status } = obj;
      if (is3DModel(obj) || is2DModel(obj)) {
        if (Number(status) === 2 || Number(status) === 6) {
          await CefSharp.BindObjectAsync("cefSharpBrower");
          cefSharpBrower.openUrl(JSON.stringify(obj));
        } else {
          this.$message.warning("文件还未轻量化,不支持预览");
        }
      } else {
        await CefSharp.BindObjectAsync("cefSharpBrower");
        cefSharpBrower.openUrl(JSON.stringify(obj));
      }
    },
    async getprjList() {
      const param = {
        enterpriseId: this.routerParams.enterpriseId || this.enterpriseId
      };
      const res = await xtDesign.queryPrj(param);
      const prjList = res.data;
      return prjList;
    },
    // 文件下载
    downLoadFile(row) {
      const fileId = row.fileId;
      const versionIds = row.versionIds;
      const url = flowFileDownLoad(this.routerParams.flowInstanceId, fileId, versionIds);
      downloadFile(url);
    },
    changePrjPlan(val) {
      if (val) {
        this.formData.prjPlanName = this.prjPlanData.find((ele) => ele.taskId === val).taskName;
      } else {
        this.formData.prjPlanName = "";
      }
    },
    focusPrjPlan() {
      if (!this.formData.carryInfoSpecialty) {
        this.$message.warning("请先选择提资专业");
      }
    },
    async viewsAndFile() {
      await CefSharp.BindObjectAsync("cefSharpBrower");
      const exportGuid = this.$route.query.exportGuid;
      const data = await cefSharpBrower.revitApproval(exportGuid); // revitApproval提资 跟校审有差别
      this.$emit('setViewsAndFileData', data);
      // fileList 是树弹窗上点击确定按钮以后返回的数据
      const fileList = JSON.parse(data) || [];
      this.formData.submitDataViewList = fileList || this.fileInfoList.slice(1) || [];
      console.log(fileList, 'fileList');
      fileList.forEach(ele => {
        ele.uploadType = 3;
        ele.fileType = Number(ele.fileType);
      });
      this.$emit("setRvtFileList", fileList || [], this.formData.submitDataViewList);
    }
  }
};
</script>

<style lang="scss" scoped>
.tzflow{
  overflow: hidden;
  .el-form-item{
    margin-bottom:5px;
    /deep/ .el-form-item__label{
      line-height: 32px;
    }
    /deep/ .el-form-item__content{
      line-height: 13px;
    }
  }
  .item-error{
    display: inline-block;
    color: #F56C6C;
    font-size: 12px;
  }
}
.tree {
  overflow: auto;
  height: 500px;
  max-height: 500px;
  width: 100%;
}
.treeitem {
  display: flex;
  align-items: center;
  user-select: none;
}
.activeShowBar {
  max-height: 300px;
  overflow-y: auto;
}
.img {
  margin-right: 6px;
  height: 16px;
  width: 18px;
  user-select: none;
}
.midd-content {
  line-height: 40px;
}
.fileList {
  width: 100%;
  max-height: 300px;
  overflow: auto;
  overflow: overlay !important;

  .file {
    width: 100%;
    height: 30px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .fileText {
      max-width: calc(100% - 50px);
      display: flex;
      align-items: center;
      position:relative;
      width: 100%;
      img {
        margin-right: 6px;
        height: 20px;
        position: absolute;
        left:15px
      }
      .fileNameStyle{
        cursor: pointer;
        position: absolute;
        left:40px
      }
    }
    .options {
      i {
        font-size: 15px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
  .file:hover {
    background: #f5f7fa;
  }
}
.treeItem {
  display: flex;
  align-items: center;
}
</style>
